/**
 * @file kirigami-spinner.component.ts
 * @description Branded loading spinner — a dual-arc circle in the
 * Kirigami primary blue (`#346a95`) that rotates via its inline
 * `<animateTransform>`. Replaces the older `kirigami-symbol.svg`
 * + CSS `.spinning` rotation used on the dashboard, report-summary,
 * and report-detail loading states.
 *
 * Usage:
 *   <app-kirigami-spinner [size]="48"></app-kirigami-spinner>
 */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Kirigami primary blue. Kept as a constant so any future retheming is one place. */
const KIRIGAMI_PRIMARY = '#346a95';

@Component({
  selector: 'app-kirigami-spinner',
  standalone: true,
  templateUrl: './kirigami-spinner.component.html',
  styleUrls: ['./kirigami-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KirigamiSpinnerComponent {
  /** Pixel size of the spinner (width == height). Defaults to 48. */
  @Input() size = 48;
  /** Accessible label for assistive tech. */
  @Input() label = 'Loading';

  readonly color = KIRIGAMI_PRIMARY;
}
